<div class="sticky-top">
  <app-header-home></app-header-home>
</div>
<div class="body">
  <div class="container-fluid">
    <div id="WrapperContent" class="col-12 col-xl-10 offset-xl-1">
      <!-- Noticias -->
      <div id="wrapper-noticias" class="styleBotonsBlog container-fluid mt-5">
        <div class="d-flex flex-column">
          <h2 class="title-section text-start my-2">Noticias</h2>
          <a routerLink="../noticias" class="btn-link-2 mb-3 hvr-forward d-flex align-items-center">
            Ver más noticias
            <span class="material-icons-outlined ms-1">add</span>
          </a>
          <!-- Desktop -->
          <div class="d-none d-xl-block">
            <div class="clusterCard d-flex flex-row">
              @for (noticia of listaNoticias; track noticia) {
                <div class="card me-3" style="width: 15rem;">
                  <img [src]="noticia.imagen" class="card-img-top" style="height: 150px;">
                  <div class="card-body">
                    <p class="card-title mb-1">{{noticia.titulo}}</p>
                    <p class="card-text mb-1">{{ noticia.fechaCreacion | date: "dd/MM/YYYY" }}</p>
                    <a href="#" [routerLink]="'/detalle/noticia/'+ transformarTitulo(noticia.titulo) +'/'+noticia.idNodo"
                    class="btn-link hvr-shrink">Ver más</a>
                  </div>
                </div>
              }
            </div>
          </div>
          <!-- Mobile -->
          <div class="d-block d-xl-none px-4">
            <div id="carouselNoticiasControls" class="carousel slide" data-bs-ride="carousel">
              <div class="carousel-inner">
                @for (noticia of listaNoticias; track noticia; let i = $index) {
                  <div class="carousel-item"
                    [ngClass]="{ 'active': i=== 0 }">
                    <div class="card card-Blog">
                      <img [src]="noticia.imagen" class="card-img-top" style="height: 150px;">
                      <div class="card-body">
                        <p class="card-title mb-1">{{noticia.titulo}}</p>
                        <p class="card-text mb-1">{{ noticia.fechaCreacion | date: "dd/MM/YYYY" }}
                        </p>
                        <a href="#" [routerLink]="'/detalle/noticia/'+ transformarTitulo(noticia.titulo) +'/'+noticia.idNodo" class="btn-link hvr-shrink">Ver
                        más</a>
                      </div>
                    </div>
                  </div>
                }
              </div>
              <button class="carousel-control-prev" type="button" data-bs-target="#carouselNoticiasControls" data-bs-slide="prev">
                <span class="material-icons-outlined">
                  arrow_back_ios
                </span>
                <span class="sr-only">Anterior</span>
              </button>
              <button class="carousel-control-next" type="button" data-bs-target="#carouselNoticiasControls" data-bs-slide="next">
                <span class="material-icons-outlined">
                  arrow_forward_ios
                </span>
                <span class="sr-only">Siguiente</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Articulos -->
      <div id="wrapper-articulo" class="styleBotonsBlog container-fluid mt-5">
        <div class="d-flex flex-column">
          <h2 class="title-section text-start mb-2">Artículos</h2>
          <a routerLink="../articulos" class="btn-link-2 mb-3 hvr-forward d-flex align-items-center">
            Ver más artículos
            <span class="material-icons-outlined ms-1">add</span>
          </a>
          <!-- Desktop -->
          <div class="d-none d-xl-block">
            <div class="clusterCard d-flex flex-row">
              @for (articulo of listaArticulos; track articulo) {
                <div class="card me-3" style="width: 15rem;">
                  <img [src]="articulo.imagen" class="card-img-top" style="height: 150px;">
                  <div class="card-body">
                    <p class="card-text mb-1">{{articulo.fechaCreacion | date: "dd/MM/YYYY" }}</p>
                    <h5 class="card-title">{{articulo.titulo}}</h5>
                    <a href="#" [routerLink]="'/detalle/articulo/'+ transformarTitulo(articulo.titulo) +'/'+articulo.idNodo" class="btn btn-primary hvr-shrink">Ver más</a>
                  </div>
                </div>
              }
            </div>
          </div>
          <!-- Mobile -->
          <div class="d-block d-xl-none px-4">
            <div id="carouselArticulosControls" class="carousel slide" data-bs-ride="carousel">
              <div class="carousel-inner">
                @for (articulo of listaArticulos; track articulo; let i = $index) {
                  <div class="carousel-item"
                    [ngClass]="{ 'active': i=== 0 }">
                    <div class="card card-Blog">
                      <img [src]="articulo.imagen" class="card-img-top" style="height: 150px;">
                      <div class="card-body">
                        <p class="card-text mb-1">{{ articulo.fechaCreacion | date: "dd/MM/YYYY"}}</p>
                        <p class="card-title">{{articulo.titulo}}</p>
                        <a href="#" [routerLink]="'/detalle/articulo/'+ transformarTitulo(articulo.titulo) +'/'+articulo.idNodo" class="btn-link hvr-shrink">Ver
                        más</a>
                      </div>
                    </div>
                  </div>
                }
              </div>

              <button class="carousel-control-prev" type="button" data-bs-target="#carouselArticulosControls" data-bs-slide="prev">
                <span class="material-icons-outlined">
                  arrow_back_ios
                </span>
                <span class="sr-only">Anterior</span>
              </button>
              <button class="carousel-control-next" type="button" data-bs-target="#carouselArticulosControls" data-bs-slide="next">
                <span class="material-icons-outlined">
                  arrow_forward_ios
                </span>
                <span class="sr-only">Siguiente</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Videos -->
      <div id="wrapper-video" class="styleBotonsBlog container-fluid mt-5">
        <div class="d-flex flex-column">
          <h2 class="title-section text-start mb-2">Videos</h2>
          <a href="http://www.youtube.com/user/bancoldex" target="_blank" class="btn-link-2 mb-3 hvr-forward d-flex align-items-center">
            Ver más videos
            <span class="material-icons-outlined ms-1">add</span>
          </a>
          <div class="d-none d-xl-block">
            <div class="clusterCard d-flex flex-row">
              @for (video of listaVideos; track video) {
                <div class="card me-3" style="width: 15rem;">
                  <div class="ratio ratio-16x9">
                    @if (youtubeConsent) {
                    <iframe class="videobkg-1 rounded p-0"
                      [src]="sanitizeUrl(video.url)"
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
                    } @else {
                    <div class="videobkg-1 rounded p-0 d-flex align-items-center justify-content-center bg-light text-center px-3">
                      <p class="mb-0 small">Active las cookies de YouTube para ver este video.</p>
                    </div>
                    }
                  </div>
                  <div class="card-body">
                    <h5 class="card-title">{{video.titulo}}</h5>
                    <p class="card-text mb-1">{{video.fechaCreacion | date: "dd/MM/YYYY" }}</p>
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="d-block d-xl-none px-4">
            <div id="carouselVideosControls" class="carousel slide" data-bs-ride="carousel">
              <div class="carousel-inner">
                @for (video of listaVideos; track video; let i = $index) {
                  <div class="carousel-item"
                    [ngClass]="{ 'active': i=== 0 }">
                    <div class="card">
                      <div class="ratio ratio-16x9">
                        @if (youtubeConsent) {
                        <iframe
                          class="videobkg-1 rounded p-0"
                          [src]="sanitizeUrl(video.url)"
                          title="YouTube video player" frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen></iframe>
                        } @else {
                        <div class="videobkg-1 rounded p-0 d-flex align-items-center justify-content-center bg-light text-center px-3">
                          <p class="mb-0 small">Active las cookies de YouTube para ver este video.</p>
                        </div>
                        }
                      </div>
                      <div class="card-body">
                        <h5 class="card-title">{{video.titulo}}</h5>
                        <p class="card-text mb-1">{{video.fechaCreacion | date: "dd/MM/YYYY" }}</p>
                      </div>
                    </div>
                  </div>
                }
              </div>

              <button class="carousel-control-prev" type="button" data-bs-target="#carouselVideosControls" data-bs-slide="prev">
                <span class="material-icons-outlined">
                  arrow_back_ios
                </span>
                <span class="sr-only">Anterior</span>
              </button>
              <button class="carousel-control-next" type="button" data-bs-target="#carouselVideosControls" data-bs-slide="next">
                <span class="material-icons-outlined">
                  arrow_forward_ios
                </span>
                <span class="sr-only">Siguiente</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Productos -->
      <div id="wrapper-producto" class="styleBotonsBlog container-fluid mt-5">
        <div class="d-flex flex-column">
          <h2 class="title-section text-start mb-4">Productos</h2>
          <div class="d-none d-xl-block">
            <div class="clusterCard d-flex flex-row">
              @for (producto of listaProductos; track producto) {
                <div class="card me-3" style="width: 15rem;">
                  <img [src]="producto.imagen" class="card-img-top img-fluid">
                  <div class="card-body card-body-1">
                    <p class="card-text mb-1">{{producto.titulo}}</p>
                    <a [href]="producto.url" class="btn-link-1 hvr-shrink" target="_blank">Ver más</a>
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="d-block d-xl-none px-4">
            <div id="carouselProductosControls" class="carousel slide" data-bs-ride="carousel">
              <div class="carousel-inner">
                @for (producto of listaProductos; track producto; let i = $index) {
                  <div class="carousel-item"
                    [ngClass]="{ 'active': i=== 0 }">
                    <div class="card">
                      <img [src]="producto.imagen" class="card-img-top img-fluid">
                      <div class="card-body card-body-1">
                        <p class="card-text mb-1">{{producto.titulo}}</p>
                        <a [href]="producto.url" class="btn-link-1 hvr-shrink" target="_blank">Ver
                        más</a>
                      </div>
                    </div>
                  </div>
                }
              </div>

              <button class="carousel-control-prev" type="button" data-bs-target="#carouselProductosControls" data-bs-slide="prev">
                <span class="material-icons-outlined">
                  arrow_back_ios
                </span>
                <span class="sr-only">Anterior</span>
              </button>
              <button class="carousel-control-next" type="button" data-bs-target="#carouselProductosControls" data-bs-slide="next">
                <span class="material-icons-outlined">
                  arrow_forward_ios
                </span>
                <span class="sr-only">Siguiente</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-body"></div>
</div>
<app-footer></app-footer>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
